let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eEfYa")).then(() => parcelRequire('8UX4o'));